<template>
  <div id="loginUser">
    <div id="modal1" class="modal">
      <div class="modal-content">
        <div class="row">
          <div class="col s12">
            <ul class="tabs">
              <li class="tab col s6">
                <a class="active" href="#loginForm"> {{ $t('loginUser.login') }} </a>
              </li>
              <li class="tab col s6">
                <a href="#registerForm"> {{ $t('loginUser.registration') }} </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <!-- Login -->
      <div id="loginForm" class="col s12">
        <div style="margin-left: 30px; margin-right: 30px; margin-bottom: 20px;">
          <ValidationObserver ref="form">
            <form @submit.prevent="onSubmit">

              <ValidationProvider rules="required|email">
                <div slot-scope="{ errors }">

                  <div class="input-field">
                    <input type="email" id="email" autocomplete="off" v-model="email"/>
                    <label for="email" class="black-text"> {{ $t('loginUser.email')}} </label>
                  </div>
                  
                  <p :style="{color: 'red'}">{{ errors[0] }}</p>
                </div>
              </ValidationProvider>

              <ValidationProvider rules="required|min:8">
                <div slot-scope="{ errors }">

                  <div class="input-field">
                    <input type="password" id="password" v-model="password" v-on:keyup.enter="loginBtnClicked"/>
                    <label for="password" class="black-text"> {{ $t('loginUser.password')}} </label>
                  </div>
                  
                  <p :style="{color: 'red'}">{{ errors[0] }}</p>
                </div>
              </ValidationProvider>

              <div v-if="errorMessage" class = 'red-text center col s12 row s12'>
                {{ errorMessage }}
              </div>

              <div class = 'right'>
                  <router-link class='grey-text' to = 'resetPassword'> {{ $t('loginUser.passwordReset') }} </router-link>
              </div>

              <div class="center-align" style="margin-top: 50px">
                <a class="btn"
                  v-on:click.prevent="loginBtnClicked"
                  :style="{width: '200px'}"
                  style="background-color: #292929"
                  > {{ $t('loginUser.login') }}
                  <i v-if="isLoading" class="fa fa-spinner fa-spin"></i>
                </a>
              </div>
            </form>
          </ValidationObserver>
        </div>
      </div>

      <!-- Register -->
      <div id="registerForm" class="col s12" style="margin-left: 30px; margin-right: 30px; margin-bottom: 90px;">
        <div class="tabs-margin">
          <div class="row">
            <form class="col s12">
              <div class="input-field col s12">
                <input id="firmenname" type="text" v-model="firmenname" />
                <label for="firmenname" class="black-text"> {{$t('loginUser.companyName')}} </label>
              </div>

              <div class="input-field col s6">
                <input id="vorname" type="text" v-model="vorname" />
                <label for="vorname" class="black-text"> {{$t('loginUser.firstName')}} </label>
              </div>
              <div class="input-field col s6">
                <input id="name" type="text" v-model="name" />
                <label for="name" class="black-text"> {{$t('loginUser.lastName')}} </label>
              </div>

              <div class="input-field col s12">
                <input id="position" type="text" v-model="position" />
                <label for="position" class="black-text"> {{ $t('loginUser.positon')}} </label>
              </div>

              <div class="input-field col s6">
                <input id="telefon" type="text" v-model="telefon" />
                <label for="telefon" class="black-text"> {{ $t('loginUser.phone')}} </label>
              </div>
              <div class="input-field col s6">
                <input id="mobil" type="text" v-model="mobil" />
                <label for="mobil" class="black-text"> {{ $t('loginUser.mobile')}} </label>
              </div>

              <div class="input-field col s6">
                <input id="handelsregister" type="text" v-model="handelsregister" />
                <label for="handelsregister" class="black-text"> {{ $t('loginUser.licenseNumber') }} </label>
              </div>
              <div class="input-field col s6">
                <input id="website" type="text" v-model="website" />
                <label for="website" class="black-text"> {{ $t('loginUser.website') }} </label>
              </div>

              <div class="input-field col s3">
                <input id="strasse" type="text" v-model="strasse" />
                <label for="strasse" class="black-text"> {{ $t('loginUser.road') }} </label>
              </div>

              <div class="input-field col s3">
                <input id="plz" type="text" v-model="plz" />
                <label for="plz" class="black-text"> {{ $t('loginUser.postCode') }} </label>
              </div>

              <div class="input-field col s3">
                <input id="ort" type="text" v-model="ort" />
                <label for="ort" class="black-text"> {{ $t('loginUser.place') }} </label>
              </div>

              <div class="input-field col s3">
                <select v-model="country">
                  <option value disabled selected> {{ $t('loginUser.country') }} </option>
                  <option value="Deutschland">Deutschland</option>
                  <optgroup label="EU">
                    <option
                      v-for="country in countryList"
                      v-bind:key="country.id"
                    >{{ country.name }}</option>
                  </optgroup>
                </select>
              </div>

              <div class="input-field col s6">
                <input id="registerEmail" type="email" class="validate" v-model="email" />
                <label for="registerEmail" class="black-text"> {{ $t('loginUser.email')}}  </label>
              </div>
              <div class="input-field col s6">
                <input id="registerPassword" type="password" class="validate" v-model="password" />
                <label for="registerPassword" class="black-text"> {{ $t('loginUser.password')}} </label>
              </div>
            </form>
            <h5 class="black-text"> {{ $t('loginUser.companyProfile') }} </h5>
          
            <p>
              <label>
                <input name="group1" type="radio" value="Freier Händler" v-model="firmenprofil"/>
                <span> {{ $t('loginUser.freeTrader') }} </span>
              </label>
            </p>
            <p>
              <label>
                <input name="group1" type="radio" value="Vertragshändler" v-model="firmenprofil" />
                <span> {{ $t('loginUser.dealer') }} </span>
              </label>
            </p>
            <p>
              <label>
                <input name="group1" type="radio" value="Niederlassung" v-model="firmenprofil" />
                <span> {{ $t('loginUser.branch') }} </span>
              </label>
            </p>
            <p>
              <label>
                <input name="group1" type="radio" value="Hersteller" v-model="firmenprofil" />
                <span> {{ $t('loginUser.manufacturer') }} </span>
              </label>
            </p>

            <div class="center-align">
              <a class="btn"  style="background-color: #292929" v-on:click="registerBtnTapped" :style="{width: '200px'}"> {{ $t('loginUser.registration') }}
              <i v-if="isLoading" class="fa fa-spinner fa-spin"></i>
              </a>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script src='https://cdnjs.cloudflare.com/ajax/libs/materialize/1.0.0/js/materialize.min.js'></script>

<script>
import firebase from "firebase";
import db from "./firebaseInit";
import { required, email } from 'vee-validate/dist/rules';
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';

extend('email', {
  ...email,
  message: 'Bitte geben Sie eine gültige E-Mail-Adresse ein'
})

extend('required', {
  ...required,
  message: 'Dieses Feld wird benötigt',
});

extend('min', {
  validate(value, args) {
    return value.length >= args.length;
  },
  params: ['length'],
  message: 'Das Passwortfeld muss aus mindestens 8 Zeichen bestehen'
});

export default {
  name: "loginUser",

  data() {
    return {
      firmenname: "",
      vorname: "",
      name: "",
      position: "",
      telefon: "",
      mobil: "",
      handelsregister: "",
      website: "",
      strasse: "",
      plz: "",
      ort: "",
      country: "",
      email: "",
      password: "",
      firmenprofil: "",

      countryName: "",
      countryList: [
        { id: 1, name: "Austria" },
        { id: 2, name: "Belgium" },
        { id: 3, name: "Bulgaria" },
        { id: 4, name: "Croatia" },
        { id: 5, name: "Cyprus" },
        { id: 6, name: "Czech" },
        { id: 7, name: "Denmark" },
        { id: 8, name: "Estonia" },
        { id: 9, name: "Finland" },
        { id: 10, name: "France" },
        { id: 11, name: "Greece" },
        { id: 12, name: "Hungary" },
        { id: 13, name: "Ireland" },
        { id: 14, name: "Italy" },
        { id: 15, name: "Latvia" },
        { id: 16, name: "Lithuania" },
        { id: 17, name: "Luxembourg" },
        { id: 18, name: "Malta" },
        { id: 19, name: "Netherlands" },
        { id: 20, name: "Poland" },
        { id: 21, name: "Portugal" },
        { id: 22, name: "Romania" },
        { id: 23, name: "Slovakia" },
        { id: 24, name: "Slovenia" },
        { id: 25, name: "Spain" },
        { id: 26, name: "Sweden" },
        { id: 27, name: "UK" }
      ],

      preisfinder: false,
      restwertkalkulator: false,
      dashboard: false,

      isLoading: false,
      errorMessage: null
    };
  },

  watch:{
      email(){
        this.errorMessage = ''
      },

      password(){
        this.errorMessage = ''
      }
  },

  mounted() {
    var modalInit = document.querySelectorAll(".modal");
    var instances = M.Modal.init(modalInit, {});

    var tabsInit = document.querySelectorAll(".tabs");
    var instance = M.Tabs.init(tabsInit, {});

    var selectInit = document.querySelectorAll("select");
    var instances = M.FormSelect.init(selectInit, {});

    // var toastInit = document.querySelector("toast")
    // var instances = M.Toast.init(toastInit, {})
  },

  components:{
    ValidationProvider,
    ValidationObserver
  },

  methods: {
    registerBtnTapped() {
      this.isLoading = true
      if (this.firmenname.length == 0 || this.vorname.length == 0 || 
          this.name.length == 0 || this.email.length == 0 || this.password.length == 0) {
          alert('Bitte füllen Sie alle geforderten Felder aus')
      } else {
           firebase
          .auth()
          .createUserWithEmailAndPassword(this.email, this.password)
          .then(
            (user) => {
              this.isLoading = false
              db.collection("user").doc(user.user.uid).set({
                  firmenname: this.firmenname,
                  vorname: this.vorname,
                  name: this.name,
                  position: this.position,
                  telefon: this.telefon,
                  mobil: this.mobil,
                  handelsregister: this.handelsregister,
                  website: this.website,
                  strasse: this.strasse,
                  plz: this.plz,
                  ort: this.ort,
                  country: this.country,
                  email: this.email,
                  firmenprofil: this.firmenprofil,
                  preisfinder: this.preisfinder,
                  restwertkalkulator: this.restwertkalkulator,
                  dashboard: this.dashboard
              })
              .then(function() {
                  console.log("Document successfully written!");
              })
              .catch(function(error) {
                  console.error("Error writing document: ", error);
              });

              this.$router.push("user");
            },
            error => {
              alert(error);
            }
          );
      }
    },

    loginBtnClicked() {

       this.$refs.form.validate().then(success => {
        if (!success) {
          return;
        }

        this.isLoading = true
        firebase
          .auth()
          .signInWithEmailAndPassword(this.email, this.password)
          .then(
            () => {
              this.isLoading = false
              var elems = document.querySelectorAll('.modal')[0];
              var instances = M.Modal.init(elems, {});
              instances.close();

              this.$router.push("user");
            },
            error => {
              this.isLoading = false

              var errorCode = error.code;
              var errorMessage = error.message;
              switch(errorCode){
                case 'auth/invalid-email':
                  this.errorMessage = errorMessage
                  // M.toast({html: errorMessage, classes: 'red-text white rounded'});
                  break
                case 'auth/user-disabled':
                  this.errorMessage = errorMessage
                  // M.toast({html: errorMessage, classes: 'red-text white rounded'});
                  break
                case 'auth/user-not-found': 
                  this.errorMessage  = errorMessage
                  // M.toast({html: errorMessage, classes: 'red-text white rounded'});
                  break
                case 'auth/wrong-password':
                  this.errorMessage = errorMessage
                  // M.toast({html: errorMessage, classes: 'red-text white rounded'});
                  break
                default:
                  this.errorMessage = errorMessage
                  // M.toast({html: errorMessage, classes: 'red-text white rounded'});
              }
            }
          );

        // Wait until the models are updated in the UI
        this.$nextTick(() => {
          this.$refs.form.reset();
        });
      });
    }
  }
};
</script>